import {stringify} from 'qs'
import request from 'utils/request'
import api from 'common/api/users'
import {format} from 'utils'

export async function sub(params) {
    return request(`${api.sub.url}?${stringify(params)}`)
}

export async function summary(params) {
    return request(`${api.summary.url}?${stringify(params)}`)
}

export async function usersSearch(params) {
    return request(`${api.usersSearch.url}?${stringify(params)}`)
}

export async function usersIndependent(params) {
    return request(`${api.usersIndependent.url}?${stringify(params)}`)
}

export async function customersSuggest(payload = {}) {
    return request(api.customersSuggest.url, {
        method: api.customersSuggest.type,
        body: payload.body,
    })
}

export async function getGroupList(params) {
    return request(`${api.getGroupList.url}?${stringify(params)}`)
}

export async function saveGroup(params = {}) {
    return request(api.saveGroup.url, {
        method: api.saveGroup.type,
        body: params.body,
    })
}
export async function editGroup(params) {
    return request(format(api.editGroup.url, {id: params.id}), {
        method: api.editGroup.type,
        body: params.body,
    })
}

export async function delGroup(params) {
    return request(format(api.delGroup.url, {id: params.id}), {
        method: api.delGroup.type,
    })
}
